import { ControlledSelectOption } from "ui";
import { AdminPostLeadReqDto } from "../../api/estabrookSchemas";

// Derived from the generated client so the values track the backend spec
// (regenerated via `yarn generate:api`). Label maps are keyed off these unions
// so a new backend value is a compile error until it gets a label.
export type DrivewaySlope = NonNullable<AdminPostLeadReqDto["slope"]>;
export type DrivewayCondition = NonNullable<AdminPostLeadReqDto["condition"]>;

export const drivewaySlopeLabelMap: Record<DrivewaySlope, string> = {
  flat: "Flat",
  upslope: "Upslope",
  downslope: "Downslope",
};

export const drivewaySlopeSelectOptions: ControlledSelectOption[] = (
  Object.keys(drivewaySlopeLabelMap) as DrivewaySlope[]
).map((value) => ({ label: drivewaySlopeLabelMap[value], value }));

export const drivewayConditionLabelMap: Record<DrivewayCondition, string> = {
  poor: "Poor",
  fair: "Fair",
  good: "Good",
  new: "New",
};

export const drivewayConditionSelectOptions: ControlledSelectOption[] = (
  Object.keys(drivewayConditionLabelMap) as DrivewayCondition[]
).map((value) => ({ label: drivewayConditionLabelMap[value], value }));

export const DRIVEWAY_DIFFICULTY_MIN = 1;
export const DRIVEWAY_DIFFICULTY_MAX = 5;

export const drivewayDifficultyMarks = Array.from(
  { length: DRIVEWAY_DIFFICULTY_MAX - DRIVEWAY_DIFFICULTY_MIN + 1 },
  (_, i) => {
    const value = DRIVEWAY_DIFFICULTY_MIN + i;
    return { value, label: String(value) };
  },
);
